
import styled from "styled-components";

/* ─────────────────────────────────────────────
 * NoEmailBottomSheet styled components
 * Mirrors the conventions in styles.grn.js:
 *   - transient props prefixed with $
 *   - template-literal CSS only (no inline styles)
 * ───────────────────────────────────────────── */

/** Outermost white panel inside GrnBottomModal */
export const EmailSheetWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 24px 0px 24px;
  background: #ffffff;
  border-radius: 20px 20px 0px 0px;
`;

/** Row that holds the sheet title (height 42 px, space-between) */
export const EmailSheetTitleRow = styled.div`
  width: 100%;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0px;
  box-sizing: border-box;
`;

/** "Enter your email address" heading */
export const EmailSheetTitle = styled.span`
  font-family: Lexend, sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: rgba(41, 49, 66, 1);
  line-height: 26px;
  letter-spacing: -0.18px;
  text-align: left;
`;

/**
 * Indigo-tinted container that wraps the input + hint text.
 * $hasError {boolean} — shrinks bottom margin when an error is shown.
 */
export const EmailInputContainer = styled.div`
  width: 100%;
  height: 106px;
  background: var(--color-base-indigo-50, rgba(244, 246, 251, 1));
  border-radius: 12px;
  margin-bottom: ${({ $hasError }) => ($hasError ? "8px" : "28px")};
  padding-bottom: 8px;
  box-sizing: border-box;
  gap: 8px;
`;

/**
 * Email address <input>.
 * $hasError {boolean} — shows red border when validation fails.
 */
export const EmailInput = styled.input`
  width: 100%;
  height: 48px;
  background: #ffffff;
  border: ${({ $hasError }) =>
    $hasError ? "1px solid #EF4F5F" : "1px solid #E6E9EF"};
  border-radius: 12px;
  padding: 0 16px;
  font-size: 14px;
  color: #293142;
  outline: none;
  box-sizing: border-box;
`;

/** Descriptive hint text rendered below the input inside the container */
export const EmailHintText = styled.span`
  display: block;
  margin-top: 8px;
  height: 42px;
  font-size: 12px;
  font-weight: 400;
  color: #767c8f;
  line-height: 14px;
  padding-left: 16px;
  padding-right: 16px;
  box-sizing: border-box;
`;

/** Inline validation error message shown beneath the container */
export const EmailErrorText = styled.span`
  font-size: 13px;
  color: #ef4f5f;
  margin-bottom: 16px;
  align-self: flex-start;
`;

/** CTA section wrapper — separating line + stacked buttons */
export const EmailCtaWrapper = styled.div`
  width: 100%;
  border-top: 0.5px solid rgba(230, 233, 239, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

/** "Not now" secondary dismiss button */
export const EmailDismissButton = styled.button`
  margin: 16px 0px;
  background: none;
  border: none;
  font-size: 14px;
  font-weight: 600;
  color: #767c8f;
  cursor: pointer;
  padding: 8px;
`;
